import * as d3 from 'd3';
import { useEffect, useState, useContext } from "react";
import { API } from "../../../API";
import { ShareAPI } from "../../../API";
import { narrativeActorsUrl } from "../../../utils/narrativeActors";
import { useTranslation } from 'react-i18next';
import { BreakdownsContext } from "./contexts/BreakdownsContext";
import {platformIconsMapping, platformNamesMapping} from '../../../utils/platforms';
import { BreakdownsContainer } from "../../../components/BreakdownsContainer/BreakdownsContainer";
import { LoaderSmall } from "../../../components/LoaderSmall/LoaderSmall";
import Tooltip from "../../../components/Tooltip/Tooltip";
import { cutString } from "../../../utils/cutString";
import { formatNumber, formatNumberSignificant, formatWithCustomGigaBillion } from '../../../utils/fomatNumbers';
import styles from '../NarrativePage.module.scss';
import { showRequestError } from '../../../utils/requestError';


export const TopActorsByPosts = ({narrative, isShare, isClickable=true, title, size=15}) => {
  const { t } = useTranslation();
  const [actors, setActors] = useState(null);

  const {openModal, setSourceFilter, setCurrentWidgetName} = useContext(BreakdownsContext);

  const api = isShare ? ShareAPI : API;

  const getActors = () => {
    const urlParams = new URLSearchParams();
    urlParams.set('size', size);
    urlParams.set('widget_name', `top_actors_by_posts_breakdown`);
    api.fetch('GET', narrativeActorsUrl(narrative.id, 'actors', urlParams)).then(
      data => setActors(data)
    ).catch(e => { showRequestError(e, t('Top actors')); setActors([]); })
  }

  useEffect(() => {
    getActors()
  }, [narrative.id])

  return(
    <BreakdownsContainer
      title={title ? title : 'Top actors by number of posts'}
      onClick={() => openModal()}
      details={false}
    >
     {actors 
      ? (actors.objects?.length > 0
      ? <div className={styles.topSourcesContainer}>
      <div className={styles.nameHeader}><h5>{t('Actor')}</h5></div>
      <div className={styles.countryHeader}><h5>{t('Country')}</h5></div>
      <div className={styles.audienceHeader}><h5>{t('Audience')}</h5></div>
      <div className={styles.messagesHeader}><h5>{t('Publications')}</h5></div>
      <div className={styles.name}>
        <div className={styles.breakdownsListMain}>
          {actors.objects.map(source => {
            return(
              <div key={`topSources_${source?.id}`} className={styles.listItem}>
                <div className={styles.info}>
                  <span>{platformIconsMapping[source?.source_type]}</span>
                  <span 
                    className={styles.title}
                    onClick={() => {
                      if (isClickable) {
                        setSourceFilter(source?.id)
                        setCurrentWidgetName('top_actors_by_posts_breakdown')
                        openModal()
                      }
                    }}
                    >
                      <Tooltip content={source.name} position='right'>
                        {cutString(source.name, 35)}
                      </Tooltip>
                    </span>
                </div>
                {/* <div className={styles.count}>{source.messages_count}</div> */}
              </div>
            )
          })}
        </div>
        
      </div>
      
      <div className={styles.country}>
        <div className={styles.breakdownsListMain}>
          {actors?.objects?.map(source => {
            return(
              <div key={`topSources_country_${source?.id}`} className={styles.listItem}>
                <div className={styles.count}>{source?.origin_country ? source?.origin_country.name : ''} &nbsp; </div>
              </div>
            )
          })}
        </div>
        
      </div>

      <div className={styles.audience}>
        <div className={styles.breakdownsListMain}>
          {actors?.objects?.map(source => {
            let followers_cnt = source?.audience;

            return(
              <div key={`topSources_audience_${source?.id}`} className={styles.listItem}>
                <div className={styles.count}>{followers_cnt === null ? '' : formatWithCustomGigaBillion(followers_cnt)} &nbsp;</div>
              </div>
            )
          })}
        </div>
      </div>

      <div className={styles.messages}>
        <div className={styles.breakdownsListMain}>
            {actors?.objects?.map(source => {
              return(
                <div key={`topSources_messages_${source?.id}`} className={styles.listItem}>
                  <div className={styles.count}>{source.messages_count}</div>
                </div>
              )
            })}
          </div>
      </div>
    </div>
      : <div className={styles.noData}>{t('There is no data to display')}</div>
      ) : (<div className={styles.widdgetLoader}><LoaderSmall /></div>)}

    </BreakdownsContainer>
  )
}

